// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateRequestedRate = (index, rate) => ({
    index,
    rate,
    type: actions.UPDATE_LABOR_RATE_REQUESTED_RATE
});

export const updateComments = (index, comment) => ({
    comment,
    index,
    type: actions.UPDATE_LABOR_RATE_COMMENT
});

export const updateEffectiveDate = effectiveDate => ({
    effectiveDate,
    type: actions.UPDATE_LABOR_RATE_EFFECTIVE_DATE
});

export const updateAverageTechPayRate = rate => ({
    rate,
    type: actions.UPDATE_LABOR_RATE_AVERAGE_TECH_PAY_RATE
});

export const updateIsSubmitDisabled = isDisabled => ({
    isDisabled,
    type: actions.UPDATE_LABOR_RATE_IS_SUBMIT_DISABLED
});

export const addFile = file => ({
    file,
    type: actions.UPDATE_LABOR_RATE_FILE
});



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/action-creators/labor-rate.js